import {
  normalizeSampleRate,
  scrubBreadcrumbData,
  scrubEvent,
} from '@argus-labs/auth-shared/telemetry'
import * as Sentry from '@sentry/react'
import { APP_VERSION, SENTRY_DSN, SENTRY_ENVIRONMENT, SENTRY_TRACES_SAMPLE_RATE } from '../env'

let sentryInitialized = false

export function initSentry(): void {
  if (sentryInitialized) return

  const dsn = SENTRY_DSN
  if (!dsn) return

  const tracesSampleRate = normalizeSampleRate(SENTRY_TRACES_SAMPLE_RATE)

  try {
    Sentry.init({
      dsn,
      environment: SENTRY_ENVIRONMENT,
      release: APP_VERSION,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate,
      sendDefaultPii: false,
      beforeSend(event) {
        scrubEvent(event)
        if (event.user) {
          delete event.user.email
        }
        return event
      },
      beforeSendTransaction(event) {
        scrubEvent(event)
        return event
      },
      beforeBreadcrumb(breadcrumb) {
        scrubBreadcrumbData(breadcrumb)
        return breadcrumb
      },
    })

    sentryInitialized = true
  } catch {
    // Swallow Sentry init errors so telemetry never crashes the app
  }
}
